 
import $ from 'jquery';

 /**
 * Unsplash integration:
 * Used for generate unsplash api calls and storing response.
 */
export default class Unsplash {

    constructor() {

        /**
         * Unsplash data from api
         *
         * @type {Array}
         */
        this._data = {
            popular: [],
            latest: [],
            oldest: [],
        }
    }

    /**
     * Call callback function
     * (you can pass additional arguments
     * after callback)
     *
     * @param  {Mixed} callback (optional)
     * @return {Void}
     */
    _call(callback) {
        if (typeof callback !== "function")
            return;

        var args = Array.prototype.slice.call(arguments, 1);
        callback.apply(this, args);
    }

    /**
     * Get unsplash api data
     *
     * @return {Array}
     */
    getFirstPage(order, callback) {
        if (!order)
            order = "popular";

        if (typeof callback !== "function")
            callback = function() {};

        if (!this._data && !this._data[order])
            return null;

        if (this._data[order].length !== 0)
            return this._call(callback, this._data[order]);

        $.ajax({
            url: window.OpsScriptData.opd_api_url + 'unsplash/' + order,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', window.OpsScriptData.nonce);
            },
            success: function(response, textStatus, jqXHR) {
                this._data[order] = response.data;

                return this._call(callback, this._data[order]);
            }.bind(this),
            error: function(jqXHR, textStatus, errorThrown) {
                // @todo - handle error
                alert("ERROR: " + textStatus);
            },
        });
    }

    /**
     * Get next page from unsplash api
     *
     * @param {Object} url
     * @param {Function} callback
     * @return {Void}
     */
    getNextPage(url, callback) {
        if (typeof callback !== "function")
            callback = function() {};

        $.ajax({
            url: url,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', window.OpsScriptData.nonce);
            },
            success: function(response, textStatus, jqXHR) {
                var regex = /<(.*?)>/g;
                var string = jqXHR.getResponseHeader('link');
                var matches, links = [];

                while (matches = regex.exec(string)) {
                    links.push(matches[1]);
                }

                var photos = response.results || response;

                var headers = {
                    urls: {
                        first: links[0] || '',
                        prev: links[1] || '',
                        last: links[2] || '',
                        next: links[3] || '',

                    },
                    total: jqXHR.getResponseHeader('x-total'),
                    perPage: jqXHR.getResponseHeader('x-per-page'),
                }

                return this._call(callback, photos, headers);
            }.bind(this),
            error: function(jqXHR, textStatus, errorThrown) {
                // @todo - handle error
                alert("ERROR: " + textStatus);
            },
        });
    }

    /**
     * Search photos from unsplash api
     *
     * @param  {Object} query
     * @param  {Function} callback
     * @return {Void}
     */
    search(query, orientation, callback) {
        if (!query)
            return;

        $.ajax({
            url: window.OpsScriptData.opd_api_url + 'unsplash/search?query=' + query + '&orientation=' + orientation,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', window.OpsScriptData.nonce);
            },
            success: function(response, textStatus, jqXHR) {
                var unsplashResponse = JSON.parse(response.data.response);

                return this._call(callback, {
                    photos: unsplashResponse.results,
                    urls: response.data.urls,
                });
            }.bind(this),
            error: function(jqXHR, textStatus, errorThrown) {
                // @todo - handle error
                alert("ERROR: " + textStatus);
            },
        });
    }

    /**
     * Event endpoint used to increment
     * the number of downloads a photo has
     *
     * @param {String} id
     * @param {Function} callback
     * @return {Void}
     */
    download(id, callback) {
        if (!id)
            return;

        $.ajax({
            url: window.OpsScriptData.opd_api_url + 'unsplash/download?id=' + id,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', window.OpsScriptData.nonce);
            },
            success: function(response, textStatus, jqXHR) {
                var unsplashResponse = JSON.parse(response.data.response);

                return this._call(callback, {
                    url: unsplashResponse.url,
                });
            }.bind(this),
            error: function(jqXHR, textStatus, errorThrown) {
                // @todo - handle error
                alert("ERROR: " + textStatus);
            },
        });
    }
}
